import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=46f57ad6&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f57ad6",
  null
  
)

export default component.exports